<style lang="scss" src="./index.scss"></style>
<template>
  <div class="page-decorate-index">
    <div class="decorate-hd">
      <div class="hd-lf">{{ localTitle }}</div>
      <div class="hd-rg">
        <el-button v-if="mode == 'page'" plain @click="onExit"> 后退 </el-button>
        <el-button v-if="mode == 'dialog'" plain @click="onClose"> 关闭 </el-button>
        <el-button plain @click="handlePreview"> 预览 </el-button>
        <el-button plain @click="onSaveTemplate"> 保存 </el-button>
      </div>
    </div>
    <div class="decorate-bd">
      <div class="left-container">
        <div class="wgt-group">
          <div class="wgt-group-title">交互组件</div>
          <div class="wgt-group-panel">
            <draggable class="wgts-view" :chosen-class="'wgts-chosen'" :list="inWidgets" :group="{
              name: 'easyview',
              pull: 'clone',
              put: false
            }" :sort="false" :clone="cloneDefaultField">
              <div v-for="(wgt, index) in inWidgets" :key="`wgt-item__${index}`" class="wgt-item" :data-name="wgt.name">
                <!-- <i
              class="wgt-icon iconfont"
              :class="wgt.wgtIcon"
                      /> -->
                <div :class="['wgt-icon', wgt.wgtIcon]" />
                <div class="wgt-name">
                  {{ wgt.wgtName }}
                </div>
                <div class="wgt-placeholder">
                  <div class="placholder-txt">放置区域</div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <div class="wgt-group" v-if="zyWidgets.length > 0">
          <div class="wgt-group-title">专用组件</div>
          <div class="wgt-group-panel">
            <draggable class="wgts-view" :chosen-class="'wgts-chosen'" :list="zyWidgets" :group="{
              name: 'easyview',
              pull: 'clone',
              put: false
            }" :sort="false" :clone="cloneDefaultField">
              <div v-for="(wgt, index) in zyWidgets" :key="`wgt-item__${index}`" class="wgt-item" :data-name="wgt.name">
                <div :class="['wgt-icon', wgt.wgtIcon]" />
                <div class="wgt-name">
                  {{ wgt.wgtName }}
                </div>
                <div class="wgt-placeholder">
                  <div class="placholder-txt">放置区域</div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
        <div class="wgt-group" v-if="fuWidgets.length > 0">
          <div class="wgt-group-title">功能组件</div>
          <div class="wgt-group-panel">
            <draggable class="wgts-view" :chosen-class="'wgts-chosen'" :list="fuWidgets" :group="{
              name: 'easyview',
              pull: 'clone',
              put: false
            }" :sort="false" :clone="cloneDefaultField">
              <div v-for="(wgt, index) in fuWidgets" :key="`wgt-item__${index}`" class="wgt-item" :data-name="wgt.name">
                <!-- <i
              class="wgt-icon iconfont"
              :class="wgt.wgtIcon"
                      /> -->
                <div :class="['wgt-icon', wgt.wgtIcon]" />
                <div class="wgt-name">
                  {{ wgt.wgtName }}
                </div>
                <div class="wgt-placeholder">
                  <div class="placholder-txt">放置区域</div>
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="center-container">
        <!-- {{ activeUUID }} -->
        <!-- {{ contentComps }} -->
        <div class="weapp-template">
          <Header v-if="headerVisible" :value="headerData" @change="handleClickHeader" />
          <div class="weapp-body" :style="weappBodyStyle">
            <draggable :list="contentComps" group="easyview" class="components-design-wrap">
              <div v-for="(wgt, index) in contentComps" v-if="wgt.name != 'page'" :key="`wgt-render-item__${index}`"
                class="wgt-render-item" :class="{ active: activeCompIndex == index }"
                @click="handleClickWgtItem(wgt, index)">
                <div class="wgt-tip">
                  {{ wgt.wgtName }}
                </div>
                <div class="wgt-tools" :class="{ active: activeCompIndex == index }">
                  <!-- <i class="iconfont icon-arrow-alt-circle-up1" @click="onMoveUpComp(index)" />
                            <i class="iconfont icon-arrow-alt-circle-dow1" @click="onMoveDownComp(index)" /> -->
                  <i v-if="enableCopy(wgt)" class="iconfont icon-copy1" @click="onCopyComp(index, wgt)" />
                  <i v-if="enableDelete(wgt)" class="iconfont icon-trash-alt1" @click="onDeleteComp(index)" />
                </div>
                <div class="wgt-render-content">
                  <component :is="wgt.name" :value="wgt" :header="headerData" :index="index" />
                </div>
              </div>
            </draggable>
          </div>
        </div>
      </div>
      <div class="right-container">
        <attrPanel :activeUUID="activeUUID" :info="panelInfo" :widgets="widgets" />
      </div>
    </div>

    <el-backtop target=".center-container" :right="520" />
  </div>
</template>

<script>
import Vue from 'vue'
import draggable from 'vuedraggable'
import { cloneDeep } from 'lodash'
import { v4 as uuidv4 } from 'uuid'
// import { SYSTEM_CONFIG } from '@/consts'
import store from '@/store'
import { hex2rgb } from '@/utils'
import { PAGE_SENCE_NUMBER } from '@/consts'
import EventBus from '@/utils/event-bus.js'
import { gWgts } from './scene/index'
import comps from './comps'
import attrPanel from './attr_panel'
import Header from './wgts/wgt_page'
import { useDialog } from '@shopex/finder'
export default {
  async beforeRouteLeave(to, from, next) {
    this.resetDecorateTheme()
    next()
  },
  components: {
    draggable,
    attrPanel,
    Header
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    mode: {
      type: String,
      default: 'page' // page || dialog
    },
    scene: {
      type: String,
      default: '1001'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localScene: '1001',
      localTitle: '',
      widgets: [],
      contentComps: [],
      activeComp: null,
      activeCompIndex: null,
      activeUUID: '',
      hackReset: true,
      headerData: null,
      headerAttr: null,
      hasPage: undefined
    }
  },
  computed: {
    weappBodyStyle() {
      const {
        pageBackgroundStyle,
        pageBackgroundColor = '#f5f5f7',
        pageBackgroundImage
      } = this.headerData || {}
      if (pageBackgroundStyle == '1') {
        return {
          'background-color': pageBackgroundColor,
        }
      } else {
        return {
          'background-image': `url(${pageBackgroundImage})`,
          'background-size': 'cover',
          'background-position': 'center',
          'background-color': pageBackgroundColor
        }
      }
    },
    headerVisible() {
      if (this.mode == 'page' && this.scene == '1001') {
        return true
      } else {
        return false
      }
    },
    inWidgets() {
      const { template_douyin = 0 } = this.$route.query
      if (template_douyin == 1) {
        return this.widgets.filter((item) => item.wgtType == 1 && item.wgtTem == 0)
      } else {
        return this.widgets.filter((item) => item.wgtType == 1)
      }
    },
    zyWidgets() {
      const { template_douyin = 0 } = this.$route.query
      if (template_douyin == 1) {
        return this.widgets.filter((item) => item.wgtType == 3 && item.wgtTem == 0)
      } else {
        return this.widgets.filter((item) => item.wgtType == 3)
      }
    },
    fuWidgets() {
      const { template_douyin = 0 } = this.$route.query
      if (template_douyin == 1) {
        return this.widgets.filter((item) => item.wgtType == 2 && item.wgtTem == 0)
      } else {
        return this.widgets.filter((item) => item.wgtType == 2)
      }
    },
    panelInfo() {
      let arr = [this.headerData, ...this.contentComps]
      return arr.filter(item => item !== null)
    }
  },
  async created() {
    document.body.style.overscrollBehaviorX = 'none'
    const { mode } = this
    if (mode == 'page') {
      const { scene = '1001' } = this.$route.query
      this.localScene = scene

      const _title = {
        1001: '商城首页装修',
        1002: '自定义模块',
        1003: '店铺装修',
        1005: '自定义页装修', // 微信小程序自定义页面
        1007: '商城首页装修', // 抖音
        1008: '自定义页装修', // 抖音
        1009: '分类页装修', // 微信小程序
        1010: '我的页装修', // 微信小程序
        // 1011: '购物袋页装修', // 微信小程序
        1012: '自定义模块AB模块', // 微信小程序
        1013:'会员权益',
        1014:'ACS权益查询',
        1016:'国补城市集合页',
        1015: '我的订单-ACS无支付落地页',
        1017:'会员中心功能页',
        1019: '会员注册承接页',
        1020: '离岛无忧',
        1021: '预约私教课程'
      }
      this.localTitle = _title[scene]
    } else {
      this.localScene = this.scene
      this.localTitle = this.title
    }
    await this.regsiterWgts()
    this.hasPage = this.widgets.find((item) => item.name.toLowerCase() == 'page')
    if (this.mode == 'page') {
      this.getTemplateDetial()
    } else {
      this.initDialogTemplate()
    }
  },
  mounted() {
    document.body.style.setProperty('--themeColor', '#155bd4')
    document.body.style.setProperty('--themeColorRgb', [21, 91, 212].join(','))
    EventBus.$on('active-wgt', (wgt) => {
      this.activeUUID = wgt.uuid
    })
  },
  destroyed() {
    document.body.style.overscrollBehaviorX = 'auto'
  },

  methods: {
    regsiterWgts() {
      const { widgets } = gWgts[this.localScene]
      Object.keys(widgets).forEach((index) => {
        this.widgets.push(widgets[index])
        Vue.component(widgets[index].name, widgets[index])
      })
    },
    resetDecorateTheme() {
      document.body.style.deleteProperty && document.body.style.deleteProperty('--themeColor')
      document.body.style.deleteProperty && document.body.style.deleteProperty('--themeColorRgb')
    },
    getComponentAttr(item) {
      const { wgtName, config } = this.widgets.find((wgt) => {
        return wgt.name.toLowerCase() == item.name.toLowerCase()
      })
      return {
        wgtName,
        ...config
      }
    },
    cloneDefaultField(e) {
      const { uuid, wgtName, wgtDesc, config } = e
      const { setting, name } = JSON.parse(JSON.stringify(config))
      const compData = {
        uuid: uuid || uuidv4(),
        name,
        wgtName,
        wgtDesc
      }
      setting.forEach((item) => {
        compData[item.key] = item.value
      })
      return compData
    },
    handleClickHeader() {
      console.log('---')
      this.activeCompIndex = null
      this.activeUUID = this.headerData.uuid
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true // 重建组件
      })
    },
    handleClickWgtItem(wgt, index) {
      if (!wgt) return
      this.activeCompIndex = index
      this.activeUUID = wgt.uuid
      this.hackReset = false
      this.$nextTick(() => {
        this.hackReset = true // 重建组件
      })
    },
    enableCopy(wgt) {
      let curWgt = null
      const { widgets } = gWgts[this.localScene]
      Object.keys(widgets).forEach((key) => {
        if (wgt.name.toLowerCase() == widgets[key].name.toLowerCase()) {
          curWgt = widgets[key]
        }
      })
      return curWgt ? (typeof curWgt.wgtCopy == 'undefined' ? true : curWgt.wgtCopy) : true
    },
    enableDelete(wgt) {
      let curWgt = null
      const { widgets } = gWgts[this.localScene]
      Object.keys(widgets).forEach((key) => {
        if (wgt.name.toLowerCase() == widgets[key].name.toLowerCase()) {
          curWgt = widgets[key]
        }
      })
      return curWgt ? (typeof curWgt.wgtDelete == 'undefined' ? true : curWgt.wgtDelete) : true
    },
    transform(wgt) {
      const { setting } = wgt.config
      return setting
    },
    normalizeTemplateValue(value) {
      if (value === 'true') return true
      if (value === 'false') return false
      if (Array.isArray(value)) return value.map(this.normalizeTemplateValue)
      if (value && typeof value === 'object') {
        return Object.keys(value).reduce((result, key) => {
          result[key] = this.normalizeTemplateValue(value[key])
          return result
        }, {})
      }
      return value
    },
    normalizeTemplateItem(item) {
      const params = item.params || item
      return this.normalizeTemplateValue(params)
    },
    async initDialogTemplate() {
      // 弹窗模式接收的是已保存的模板数据，需要还原成装修器内部可编辑的数据结构。
      const list = Array.isArray(this.value) ? this.value : []
      const results = await Promise.all(list.map(async (li) => {
        // 旧模板里文章组件曾存为 article，这里统一转成当前组件名 articleBlock。
        if (li.name === 'article') li = { ...li, name: 'articleBlock' }
        if (li.params && li.params.name === 'article') {
          li = { ...li, params: { ...li.params, name: 'articleBlock' } }
        }
        const wgt = this.widgets.find((item) => item.name.toLowerCase() == li.name.toLowerCase())
        if (!wgt) return null
        const wgtInitParams = this.cloneDefaultField(wgt)
        const params = await wgt.config.transformIn(this.normalizeTemplateItem(li), this.widgets)
        return {
          wgtName: wgt.wgtName,
          ...wgtInitParams,
          ...params
        }
      }))
      this.contentComps = results.filter(result => result !== null && result.name != 'page')
      if (this.contentComps.length > 0) {
        this.handleClickWgtItem(this.contentComps[0], 0)
      }
    },
    async getTemplateDetial() {
      const { template_id } = this.$route.query
      let list = []
      try {
        if (this.localScene == '1004' || this.localScene == '1005' || this.localScene == '1008') {
          const resTemplate = await this.$api.wxa.getParamByTempName({
            template_name: 'yykweishop',
            page_name: `custom_${template_id}`,
            version: 'v1.0.1'
          })
          list = resTemplate.list || []
        } else {
          const { template_content } = await this.$api.template.getPagesTemplateDetail({
            pages_template_id: template_id
          })
          list = template_content.list || []
        }
        if (list.length == 0) {
          list = gWgts[this.localScene].initiWidgets
        }
      } catch (e) {
        console.error(e)
      }

      const results = await Promise.all(list.map(async (li) => {
        // 文章组件曾用名 `article` 与原生 <article> 冲突，旧模板兼容为 articleBlock
        if (li.name === 'article') li = { ...li, name: 'articleBlock' }
        if (li.params && li.params.name === 'article') {
          li = { ...li, params: { ...li.params, name: 'articleBlock' } }
        }
        // 是否存在挂件
        const wgt = this.widgets.find((item) => item.name.toLowerCase() == li.name.toLowerCase());
        if (wgt) {
          const wgtInitParams = this.cloneDefaultField(wgt);
          const params = await wgt.config.transformIn(li.params, this.widgets);
          return {
            wgtName: wgt.wgtName,
            ...wgtInitParams,
            ...params
          };
        }
        return null; // Return null or an appropriate placeholder if no widget is found
      }));

      // Filter out any null values if necessary
      this.contentComps = results.filter(result => result !== null && result.name != 'page');
      if (this.hasPage) {
        const wgtHeader = results.find((item) => item.name == 'page')
        if (!wgtHeader) {
          // 页面设置初始数据
          const { setting, name } = Header.config
          let defaultHeaderParams = {
            uuid: uuidv4(),
            name,
            wgtName: Header.wgtName,
            wgtDesc: Header.wgtDesc
          }
          setting.forEach((item) => {
            defaultHeaderParams[item.key] = item.value
          })
          this.headerData = defaultHeaderParams
        } else {
          this.headerData = wgtHeader
        }
        this.headerAttr = {
          wgtName: Header.wgtName,
          ...Header.config
        }
        setTimeout(() => {
          this.handleClickHeader()
        }, 200)
      } else {
        this.handleClickWgtItem(this.contentComps[0], 0)
      }
      console.log('getTemplateDetial:', this.contentComps)
    },
    onMoveUpComp(index) {
      // this.contentComps
    },
    onMoveDownComp(index) { },
    onCopyComp(index, wgt) {
      const data = Object.assign(cloneDeep(wgt), { uuid: uuidv4() })
      this.contentComps.splice(index + 1, 0, data)
    },
    onDeleteComp(index) {
      if (this.contentComps.length == index + 1 && this.hasPage) {
        setTimeout(() => {
          this.handleClickHeader()
        }, 20)
      }
      this.contentComps.splice(index, 1)
    },
    async onSaveTemplate() {
      const contentComps = this.contentComps.filter((item) => item.name.toLowerCase() != 'functionBlock')
      try {
        if (this.mode == 'dialog') {
          const data = contentComps.map((item) => {
            const wgt = this.widgets.find(
              (wgt) => wgt.name.toLowerCase() == item.name.toLowerCase()
            )
            const { transformOut } = wgt.config
            const wgtInitParams = this.cloneDefaultField(wgt)
            return transformOut({
              ...wgtInitParams,
              ...item
            }, this.widgets)
          })
          this.resetDecorateTheme()
          this.$emit('change', data)
          return
        }

        const data = contentComps.map((item) => {
          const { transformOut } = this.widgets.find(
            (wgt) => wgt.name.toLowerCase() == item.name.toLowerCase()
          ).config
          return transformOut(item, this.widgets)
        })

        const filterStoreList = data.filter((el) => el.name == 'storeRuleList')
        if (filterStoreList.length > 1) {
          this.$message.error('门店规则列表，只能设置一个!')
          return
        }
        if (filterStoreList.length && filterStoreList[0].config.num < 0) {
          this.$message.error('门店规则列表，高度应大于0!')
          return
        }

        if (this.hasPage) {
          data.unshift(this.headerAttr.transformOut(this.headerData))
        }
        const { template_id: id } = this.$route.query
        if (this.localScene == '1005' || this.localScene == '1008') {
          await this.$api.wxa.savePageParams({
            template_name: 'yykweishop',
            page_name: `custom_${id}`,
            version: 'v1.0.1',
            config: JSON.stringify(data)
          })
        } else if (this.localScene == '1002') {
          let pendant_data = []
          pendant_data.is_ab = ''
          data.filter((item) => {
            if (item.name.toLowerCase() == 'abtest') {
              pendant_data.is_ab = 1
            }
          })
          await this.$api.template.savePagesTemplate({
            pages_template_id: id,
            template_content: JSON.stringify({
              content: data
            }),
            pendant_data
          })
        } else if (this.localScene == '1011') {
          await this.$api.template.savePagesTemplate({
            pages_template_id: id,
            template_content: JSON.stringify({
              content: data
            })
          })
        } else if (this.localScene == '1009' || this.localScene == '1010' || this.localScene == '1011') {
          await this.$api.template.savePagesTemplate({
            pages_template_id: id,
            weapp_pages: PAGE_SENCE_NUMBER[this.localScene],
            template_name: 'yykweishop',
            template_content: JSON.stringify({
              content: data
            })
          })
        } else {
          await this.$api.template.savePagesTemplate({
            pages_template_id: id,
            template_name: 'yykweishop',
            template_content: JSON.stringify({
              content: data
            })
          })
        }
        this.$message.success('保存成功')
      } catch (error) {
        this.$message.error(error)
      }
    },
    onExit() {
      this.$router.go(-1)
    },
    onClose() {
      this.resetDecorateTheme()
      this.$emit('close')
    },
    handlePreview() {
      useDialog(null, {
        title: `预览`,
        width: '840px',
        top:'10px',
        data: this.panelInfo,
        component: () => import('./preview.vue'),
        actions: []
      })
    }
  }
}
</script>
